export default __webpack_public_path__ + "static/media/26.70e143b9.png";